import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { ErrorState } from '../../../types/AppTypes';
import { setError } from '../../../redux/actions';

const ErrorModal = () => {
  const errorState: ErrorState = useAppSelector((state) => state.application);

  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setError({ hasError: false, errorMessage: '' }));
  };
  return (
    <Dialog
      open={errorState.hasError}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Something Went Wrong!'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{errorState.errorMessage}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;
